import { Injectable } from "@angular/core";
import { EnvConfigProvider } from "./env-config.provider";
import { DebugLevel } from "./models/env-config.model";

@Injectable({
	providedIn: "root"
})
export class DebugService {
	private debugLevel: DebugLevel;
	constructor(private envConfigProvider: EnvConfigProvider) {
		this.debugLevel = this.envConfigProvider.debugLevel;
	}

	public dev(...args: any[]) {
		if (DebugLevel.dev >= this.debugLevel) {
			console.log(...args);
		}
	}

	public staging(...args: any[]) {
		if (DebugLevel.staging >= this.debugLevel) {
			console.log(...args);
		}
	}

	public prod(...args: any[]) {
		if (DebugLevel.prod >= this.debugLevel) {
			console.log(args);
		}
	}
}
